
  // This file was autogenerated by dynamically running setEnv.ts and using dotenv for managing API key secrecy
  export const environment = {
    production: true,
    apiUrl: 'https://crm.car-bro.com/api/v1',
    token: 'fb07f19acf36d4a2a85cf176ed360dc75df7d4d2d3c545eda4e444cb791cbf91',
    contract: 'CAR-BRO',
  };
